const workspace = new Set(
  "calendar conversations documents work finance sales technical shares dashboard clean-control automations dxf-library projects flows reports canvases connect templates integrations".split(
    " ",
  ),
);
const settings = new Set(
  "memory marp-templates security shortcuts organization changelog skills billing help presentations privacy notifications modes brand-kits".split(
    " ",
  ),
);
const consolePages = new Set(
  "apps access schema keys developers flows billing connectors get-started actions playground embedded-identity members models accounts limits usage traces docs documents".split(
    " ",
  ),
);

/** Finite screen labels: never expose resource IDs, searches, tokens, or document titles. */
export function platformPath(value: string): string | null {
  let pathname: string;
  try {
    pathname = new URL(value, "https://ando-ai.com").pathname.replace(/\/$/, "");
  } catch {
    return null;
  }
  const parts = pathname.split("/").filter(Boolean);
  const [area, section, detail, extra] = parts;
  if (area === "console") {
    if (!section) return "/console";
    if (consolePages.has(section) && parts.length === 2) return `/console/${section}`;
    if (
      detail &&
      parts.length === 3 &&
      ["keys", "connectors", "flows", "document-access", "connection-access"].includes(
        section ?? "",
      )
    )
      return `/console/${section}/detail`;
    return null;
  }
  if (area === "settings")
    return parts.length === 1
      ? "/settings"
      : parts.length === 2 && settings.has(section ?? "")
        ? `/settings/${section}`
        : null;
  if (area === "engine" && section === "get-started" && parts.length === 2)
    return "/engine/get-started";
  if (area === "integrations")
    return parts.length === 1
      ? "/integrations"
      : parts.length === 2
        ? "/integrations/detail"
        : null;
  if (area !== "workspace" || !workspace.has(section ?? "")) return null;
  if (parts.length === 2) return `/workspace/${section}`;
  if (
    parts.length === 3 &&
    ["projects", "reports", "canvases", "connect", "integrations"].includes(section ?? "")
  )
    return `/workspace/${section}/detail`;
  if (section === "flows" && detail) {
    if (parts.length === 3) return "/workspace/flows/editor";
    if (parts.length === 4 && extra === "run") return "/workspace/flows/run";
  }
  if (section === "templates") {
    if (parts.length === 3 && detail !== "edit") return "/workspace/templates/gallery";
    if (parts.length === 4 && detail === "edit") return "/workspace/templates/editor";
  }
  return null;
}
